import { getUrlParameter } from "./Helpers";

//TODO move these to an env variable
const deployment = getUrlParameter('deployment');
let whitelisted = [];
let env = "DEV";
let tenant = "";
let clientId = "a8250ca6-8c32-49ba-8749-5833626c3ed3";
let scope = "https://graph.microsoft.com/.default";
let graphUrl = "https://graph.microsoft.com";
// TODO eShare labels test
if (deployment === 'eshare_gov_com' || deployment === 'esg') {
    tenant = deployment === 'esg' ? "ESG demo" : "eshare";
    whitelisted = [
        "2963af5f-f85b-4244-bda2-c73b3044a022",
        "d6be73be-8dd7-471c-bd7b-886a84fb3ad8",
        "946e32bd-93eb-457d-b3dc-d89da83242e0",
    ];
} else if (deployment === 'eshare' || deployment === 'ge_prod_gov') { // TODO when GE gets new manifest we can remove "eshare" deployment legacy support.
    tenant = "GE";
    // GE labels
    if (typeof window !== 'undefined' && window.location?.hostname === "pep-prod.e-share.us"){
        whitelisted = [
            "188278aa-850a-482b-8359-85a8fc645e19",
            "2ee2cb07-afc5-405e-a0fc-62696d284110",
            "a376b2e8-1f7c-4bce-83bd-771269b9b3bb",
        ];
    } else {
        whitelisted = [
            "082f724a-d280-4b8f-9f84-6a11ffc931df",
            "3cb564be-5540-4053-85e8-eb564cc8f75d",
            "9785498a-9088-4fcf-87bf-fe30b64745e1",
            "125ac830-4fa3-4295-98b5-1c0c939df0b5",
            "93b68801-e10f-48d9-9ed4-5d8b7b3ccbcf",
            "ad247983-b85e-4725-9397-d67164841db9",
        ];
    }
} else if (deployment === 'eshare_staging') {
    tenant = "eshareitar";
    // Eshareitar stage labels
    whitelisted = [
        "892415b1-b768-4d40-a005-4effd5b31f37", // 1. Internal
        "95fe9658-5086-4277-81d7-4e8d34001e73", // 2. Automation
        "20fda2d1-9bd4-4d1b-b4a2-20c48fa182d8", // 3. General Docs
    ];
} else if (deployment === 'humana') {
    tenant = "Humana";
    // Humana
    whitelisted = [
        "4f18fb02-f4bb-4b0f-bfc4-ece2c9e86b39",
        "45cb386a-0d24-424b-96d8-7383b2c2a6c1",
        "08f6de87-27b6-4643-97d1-2508e65c9b24",
    ];
} else if (deployment === 'ge_prod_commercial') {
    tenant = "GE Commercial";
    // GE Commercial
    whitelisted = [
        "e0605f16-fcf5-43c1-b15e-77a4676fcf83",
        "c57929d3-15b0-4d19-9496-10f75a0b29fe",
        "6b875261-26f0-4a6c-91fb-a8938cecd372",
    ];
} else if (deployment === 'ge_dev_commercial') {
    tenant = "GE DEV Commercial";
    // GE DEV Commercial
    whitelisted = [
        "bf45ccbf-720f-472d-b3ad-8f0ef987d79c",
        "9ea298ac-500f-414f-ab93-d2dee2e341cc",
        "d961eb10-e946-44b9-927e-a7d3e66ba46a",
    ];
} else if (deployment === 'humtestmail') {
    tenant = "Humtestmail staging";
} else if (deployment === 'hanwha') {
    tenant = "Hanwha";
    // Hanwha labels
    whitelisted = [
        "5b788aed-bc5c-4280-9e09-78ec58ec1922",
        "0f698505-f14a-48fa-81cf-40281a019476",
        "555c56e6-d3ef-4a47-9e9e-29ee11e699ab",
    ];
}
// TODO whitelisted labels for other gcchdev.



export const ignoreChecksLabelsId = whitelisted;

let msAuthority: string = 'https://login.microsoftonline.com/common';
let serverUrl = getUrlParameter('server_url');

if (!serverUrl && typeof localStorage !== 'undefined') {
    // This runs at MODULE TOP LEVEL, evaluated on import before any of this app's own code -
    // including every guard in index.tsx - gets a chance to run. A corrupted GeApiState value
    // must not throw here: unlike a throw inside a function, an uncaught exception during
    // module evaluation aborts the entire bundle, so nothing after this point ever executes -
    // not App, not NonOfficeApp, not the office.js bootstrap diagnostics, nothing. That is a
    // more severe failure than anything those diagnostics are designed to catch: a blank page,
    // no error, no telemetry, on every surface, and the earliest point a fix could take effect.
    try {
        const state = JSON.parse(localStorage.getItem("GeApiState"));
        serverUrl = state?.serverUrl;
    } catch {
        // Fall through with serverUrl left as whatever getUrlParameter('server_url') gave -
        // same as the pre-existing "no GeApiState at all" case.
    }
}

const normalizedServerUrl = serverUrl?.replace(/\/+$/, '');

switch (normalizedServerUrl) {
    case "https://secure.eshare.com" :
    case "https://www.ncryptedcloud.com" :
        clientId = '40b91beb-90d2-4558-998a-78322682a6fe';
        env = "PROD";
        break;
    case "https://ppe.eshareitar.com" :
        clientId = 'a8250ca6-8c32-49ba-8749-5833626c3ed3';
        env = "PPE";
        break;
    case "https://app.e-sharegov.us" :
        clientId = 'dfcd62ae-ef4b-4c94-b2fc-72665cfa398c'; // PROD GOV
        msAuthority = "https://login.microsoftonline.us/common";
        scope = "https://graph.microsoft.us/.default";
        graphUrl = "https://graph.microsoft.us";
        env = "PROD";
        break;
    case "https://staging.gcchdev.com" :
        clientId = 'd9ea83e6-783e-4968-8201-4b5cb4e6f379';
        msAuthority = "https://login.microsoftonline.us/common";
        scope = "https://graph.microsoft.us/.default";
        graphUrl = "https://graph.microsoft.us";
        env = "STAGING GOV";
        break;
    case "https://cloud.humtestmail.com" :
        env = "STAGING Humtestmail";
        break;
    default :
        env = "DEV";
        break;
}

export const CLIENT_ID = clientId;
export const MS_AUTHORITY = msAuthority;
export const APM_ENV = `${tenant} - ${env} - ${serverUrl?.replace('https://', '')}`;
export const BYPASS_KEYWORD = "[#bypass]";

export const initialErrorData = {
    customError: undefined,
    asyncResultValue: undefined,
    asyncResultStatus: undefined,
    asyncErrorMessage: undefined,
    labelId: undefined,
    catalog: undefined
}

export const GRAPH_SCOPE = [
    scope,
];

export const GRAPH_ENDPOINT = graphUrl;
// In Playwright/node, __DEV__ may be undefined. In that case, treat it as "not dev"
// so SERVER_URL resolves to serverUrl (not "").
const isDev = (typeof __DEV__ !== "undefined") && Boolean(__DEV__);
export const SERVER_URL = isDev ? "" : serverUrl;
// TODO check out if https://github.com/validatorjs/validator.js/ is a better option performance and maintenance wise.
export const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

// Shared bound for Office.js host-callback calls (getAsync/setAsync-style) that can hang indefinitely
// if the native callback never fires, so every wrapped call times out consistently.
export const OFFICE_JS_CALL_TIMEOUT_MS = 10000;

// saveAsync round-trips to Exchange and, when a protected sensitivity label is applied, through the
// MIP service to encrypt before it returns. That is legitimately slower than a local Office.js read,
// so it gets its own budget rather than sharing OFFICE_JS_CALL_TIMEOUT_MS. Observed p99 on the
// affected tenant is ~3s (AB#14110); 30s bounds the wedge without firing on a slow-but-working save.
export const SAVE_DRAFT_TIMEOUT_MS = 30000;

// Bound for outbound HTTP calls on the send path.
export const HTTP_REQUEST_TIMEOUT_MS = 30000;

// Bound for notification updates on error/recovery paths. These run immediately after another host
// call has already failed or timed out, i.e. exactly when Office.js has proven unresponsive, so an
// unbounded one re-wedges the send after the first timeout fired (AB#14110). They are cosmetic banner
// updates: abandon them quickly and let the send resolve rather than blocking on a UI nicety.
export const NOTIFICATION_TIMEOUT_MS = 3000;

// Wall-clock budget for expanding every distribution list on a single send. Nested DLs fan out into
// an unbounded number of Graph round-trips, and the send path has no other bound on them (AB#14110
// wrapped the Office.js and HTTP calls but not this traversal), so a deeply nested DL wedges the
// ItemSend handler until Outlook kills it with "Secure Email timed out.". When the budget is spent
// the traversal stops and the remaining lists fail *open*: the DL address itself is handed to the
// server instead of its members, so the send still completes.
//
// Measured cost at DL_EXPANSION_CONCURRENCY is ~25ms per nested group on a 250ms Graph round-trip and
// ~50ms on a 500ms one, so 45s covers a list of roughly 900 nested groups even on a slow client.
//
// That is deliberately generous, and the reason is what failing open costs: a list we give up on is
// sent to the server as a bare address, so none of its members are checked individually. A shorter
// budget trades a shorter frozen send for more sends going out only partly validated. Erring long
// keeps the validation gap rare, and the budget only ever binds on lists far past anything real.
export const DL_EXPANSION_BUDGET_MS = 45000;

// Hard cap on how deep nested groups are followed. Azure AD allows cycles (A contains B contains A),
// which this bounds together with the per-traversal visited set.
export const DL_MAX_NESTING_DEPTH = 10;

// How many nested groups are expanded in parallel. Sibling expansions are independent, and running
// them one at a time is what makes a wide DL tree take minutes. Ten is what lets DL_EXPANSION_BUDGET_MS
// stay short: it halves the wall clock against five, so a shorter budget still completes more real
// lists. Directory reads are cheap and this is per-client, so it is nowhere near Graph's throttle.
export const DL_EXPANSION_CONCURRENCY = 10;

// Cap on how many individual expansion problems are shipped to APM per send. The payload has to be
// delivered in the narrow window between transaction.end() and Outlook tearing down the webview, so a
// list with thousands of unresolvable members must not turn one send into a huge document.
export const DL_MAX_REPORTED_DIAGNOSTICS = 50;

export const DECISION_OVERRIDE = "override_approval";
export const DECISION_ACCEPT = "accept_removal";
export const SW_VERSION = "1.0.1"; // Version of the service worker, alter to force update.
export const ATTEMPTS_TO_SEND_AUDIT = 10; // Default number of attempt to send audit event to the server via localstorage beofre marking as failed.
export const AUDIT_TTL_MS = 3 * 24 * 60 * 60 * 1000; // 3 days storage TTL in localstorage.